import './i18n';
import './App.css';

import { NavigationProvider, PageSection } from './context/NavigationContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import DownloadPage from './pages/DownloadPage';
import FeaturesPage from './pages/FeaturesPage';
import SecurityPage from './pages/SecurityPage';
import FAQPage from './pages/FAQPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import CGUPage from './pages/CGUPage';
import AboutPage from './pages/AboutPage';
import TrustSecurityPage from './pages/TrustSecurityPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

const SPAContent = () => {
  return (
    <>
      <PageSection id="home"><HomePage /></PageSection>
      <PageSection id="download"><DownloadPage /></PageSection>
      <PageSection id="features"><FeaturesPage /></PageSection>
      <PageSection id="securite"><SecurityPage /></PageSection>
      <PageSection id="faq"><FAQPage /></PageSection>
      <PageSection id="mentions-legales"><MentionsLegalesPage /></PageSection>
      <PageSection id="politique-confidentialite"><PolitiqueConfidentialitePage /></PageSection>
      <PageSection id="conditions-utilisation"><CGUPage /></PageSection>
      <PageSection id="about"><AboutPage /></PageSection>
      <PageSection id="trust-security"><TrustSecurityPage /></PageSection>
      <PageSection id="blog"><BlogPage /></PageSection>
      <PageSection id="blog-article"><BlogPostPage /></PageSection>
    </>
  );
};

function App() {
  return (
    <NavigationProvider>
      <div className="min-h-screen bg-lumina-dark text-white font-sans antialiased pb-20 md:pb-0 overflow-x-hidden">
        <Navbar />
        <SPAContent />
        <Footer />
      </div>
    </NavigationProvider>
  );
}

export default App;
